<dialog-header
  [title]="'Adjust Points'"
  (onClose)="matDialogRef.close()"
></dialog-header>

<div
  mat-dialog-content
  style="
    padding-bottom: 20px;
    border-top: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
    background-color: var(--app-container);
  "
>
  <loader [loading]="cardsLoading"></loader>

  <form
    *ngIf="!cardsLoading && !customersLoading && form"
    [formGroup]="form"
    (ngSubmit)="primaryTapped()"
    style="margin-top: 20px"
  >
    <!-- Customer Selection (if no customer provided) -->
    <div
      class="form-field"
      style="margin-top: 20px"
      *ngIf="showCustomerSelection"
    >
      <single-select
        label="Customer"
        [formCtrl]="customerFormControl"
        [options]="customers"
        [inBrackets]="'email'"
        [property]="'name'"
        [showSearch]="true"
        (selected)="onCustomerSelected($event)"
      ></single-select>
    </div>

    <!-- Card Selection (if multiple cards available) -->
    <div class="form-field" style="margin-top: 20px" *ngIf="showCardSelection">
      <single-select
        label="Select Card"
        [formCtrl]="cardSelectionFormControl"
        [options]="availableCards"
        property="cardTitle"
        [inBrackets]="'info'"
      ></single-select>
    </div>

    <!-- Adjustment Mode Selection -->
    <div class="form-field" style="margin-top: 20px" *ngIf="selectedCustomer">
      <single-select
        label="Adjustment Type"
        [formCtrl]="adjustmentModeFormControl"
        [options]="adjustmentModes"
        property="label"
      ></single-select>
    </div>

    <div class="form-field" style="margin-top: 20px" *ngIf="isConvertMode">
      <single-select
        label="Select Reward"
        [formCtrl]="rewardFormControl"
        [options]="rewards"
        [inBrackets]="'_points'"
        property="title"
        [disabled]="rewardsLoading"
      ></single-select>
      <div
        class="error-message"
        style="color: red; font-size: 12px; margin-top: 5px"
        *ngIf="rewardFormControl.invalid && rewardFormControl.touched"
      >
        Please select a reward
      </div>
      <div
        *ngIf="rewardsLoading"
        style="color: #666; font-size: 12px; margin-top: 5px"
      >
        Loading rewards...
      </div>
    </div>

    <!-- Points Input -->
    <div class="form-field" style="margin-top: 20px">
      <div class="form-field-label">
        <span *ngIf="!isConvertMode && adjustmentModeFormControl?.value"
          >New Points Total<span style="color: red">*</span></span
        >
        <span *ngIf="isConvertMode && rewardFormControl?.value"
          >Points After Conversion<span style="color: red">*</span></span
        >
      </div>
      <input
        *ngIf="
          (rewardFormControl?.value || !isConvertMode) &&
          adjustmentModeFormControl?.value
        "
        class="form-input"
        autocomplete="off"
        [maxlength]="8"
        [formControl]="pointsFormControl"
        type="number"
        [placeholder]="
          isConvertMode ? 'Calculated automatically' : 'Enter new points total'
        "
        min="0"
        [max]="maxPoints"
        [readonly]="isConvertMode"
        oninput="
          javascript: if (this.value.length > this.maxLength)
            this.value = this.value.slice(0, this.maxLength);
        "
      />
    </div>

    <!-- Immediate Redemption Option (only shown in convert mode) -->
    <div
      class="form-field"
      style="margin-top: 20px; display: flex; justify-content: space-between"
      *ngIf="isConvertMode && selectedReward"
    >
      <div class="form-field-label">Mark reward as redeemed immediately</div>
      <mat-slide-toggle
        [disabled]="false"
        [formControl]="redeemImmediatelyFormControl"
      >
      </mat-slide-toggle>
    </div>
  </form>
</div>

<div mat-dialog-actions align="end">
  <app-secondary-button
    style="margin-right: 10px"
    [title]="'Cancel'"
    [disabled]="loading"
    (tapped)="matDialogRef.close()"
  ></app-secondary-button>

  <app-primary-button
    [title]="'Save'"
    [disabled]="!canSubmit()"
    (tapped)="primaryTapped()"
    bgColor="var(--app-timber)"
    color="white"
  ></app-primary-button>
</div>

<loader [loading]="loading || customersLoading"></loader>
